import "./ModalMessage.scss";

type ModalPropsType = {
    message: string,
    title: string,
    icon: string,
    onClose?: () => void
    handleCardClickFunc?: any
}

/**
 * @param {string}message the message of the modal
 * @param {string}title the title of the message
 * @param {string}icon the title icon
 * @param {function}onClose the function to close the modal
 */

const ModalMessage = ({message, title, icon, onClose, handleCardClickFunc} : ModalPropsType) => {
    
    //funzione per evitare la chiusura della modale al click sulla card
    const handleCardClick = handleCardClickFunc ? handleCardClickFunc : (e : any) => e.stopPropagation();

    return (
        <div 
            className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2" 
            data-testid="modal-message-card"
            onClick={handleCardClick}>
            <div className="ModalMessage__card" >
                {/* Pulsante per la chiusura della modale*/} 
                <i onClick={onClose} className="ModalMessage__button bi bi-x-circle"></i>
                <p className="ModalMessage__title">
                    <i className={`ModalMessage__icon ${icon}`}></i>
                    {title}
                </p>
                {/* Testo della card della modale*/} 
                <p className="ModalMessage__message">{message}</p>
            </div>
        </div>
    );
};

export default ModalMessage;
